import { pathJoin } from 'src/reducers/routing/utils'

export const createUserMangementRoutesMap = (prefix: string) => ({
  users: pathJoin(prefix)('users').chain,
  roles: pathJoin(prefix)('roles').chain,
  'roles/:id': (id = ':id') => pathJoin(prefix)('roles', id).chain,
  teams: pathJoin(prefix)('teams').chain,
  'shift-planner': pathJoin(prefix)('shift-planner').chain,
})
